<template>
  <div
    ref="draftCardCreate"
    slot="footer"
    class="draft-card-create"
  >
    <div
      v-if="!draftCardCreateView"
      v-draghover="'create-add-button__dragging-on'"
      :data-selected-card="$store.getters.selectedCardId === `add-card-${listId}`"
      class="create-add-button usn pt"
      @click="createDraftCard"
    >
      <em
        class="custom-icons usn drag-scroll-disable"
        :style="getCustomIconStyle(iconPath('plus2'))"
      />
      <span class="usn drag-scroll-disable">{{ label }}</span>
      <ShortcutKeyPill
        v-if="!isEpicsBoard"
        class="create-shortcut-key-pill"
        :text="'C'"
        :background-color="key.background"
        :font-color="key.text"
        :border-color="key.border"
      />
    </div>
  </div>
</template>

<script>
import EventBus from '@/utilities/eventBus';
import ShortcutKeyPill from '@/components/functional/ShortcutKeyPill';
import defaultShortcutKeyPillStyle from '@/mixins/defaultShortcutKeyPillStyle';
import useCustomIcon from '@/utilities/composables/useCustomIcon';

export default {
  name: 'AddNewCardButton',
  components: {
    ShortcutKeyPill,
  },
  mixins: [defaultShortcutKeyPillStyle],
  props: {
    listId: {
      type: [String, Number],
      required: true,
    },
    parentListId: {
      type: [String, Number],
      default: '',
    },
  },
  setup() {
    const { getCustomIconStyle, iconPath } = useCustomIcon();

    return {
      iconPath,
      getCustomIconStyle,
    };
  },
  data() {
    return {
      draftLoaded: false,
    };
  },
  computed: {
    listDraftCardCreateView() {
      return this.$store.getters.getListDraftCardCreateView;
    },
    draftCardCreateView() {
      return this.listId === this.listDraftCardCreateView;
    },

    isEpicsBoard() {
      return (
        this.$store.getters.currentBoardId === this.$constants.epicsBoardId &&
        this.$route.name === this.$constants.epicsBoardRoute.name
      );
    },
    label() {
      return this.translate(this.isEpicsBoard ? 'addProject' : 'addCard');
    },
  },
  mounted() {
    EventBus.$on('addCardButton:click', this.addCardMessageHandler);
  },
  unmounted() {
    EventBus.$off('addCardButton:click', this.addCardMessageHandler);
  },
  methods: {
    createDraftCard(event) {
      if (
        ![this.$constants.routeNames.board, this.$constants.epicsBoardRoute.name].includes(
          this.$route.name
        )
      ) {
        if (event) {
          event.stopPropagation();
        }
      }
      const listId = this.parentListId !== '' ? `${this.parentListId}-${this.listId}` : this.listId;
      this.$store.dispatch('setListDraftCardCreateView', listId);
      EventBus.$emit('focusDraftCardInput', { listId: this.listId });
    },

    addCardMessageHandler(listId) {
      if (listId === this.listId) {
        this.createDraftCard();
      }
    },

    cancelAddNewCard() {
      this.$store.dispatch('setListDraftCardCreateView', '');
    },
  },
};
</script>

<style lang="scss">
.draft-card-create {
  padding: 0px;
  width: $columnWidth;
  height: $boardNewCardHeight;

  .create-add-button {
    display: flex;
    align-items: center;
    font-family: $primaryFontFamily;
    border-radius: 8px;
    padding: 10px 15px;
    background: transparent;
    @apply text-text-default;

    span {
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
    }
    em.custom-icons {
      @apply text-icon-default mr-1;
    }

    .create-shortcut-key-pill {
      opacity: 0;
      margin-left: auto;
    }

    &:hover {
      @apply bg-hover-default;

      .create-shortcut-key-pill {
        opacity: 1;
      }
    }

    &__dragging-on {
      cursor: default !important;
      &:hover {
        @apply bg-transparent;
      }
    }
  }
}

[data-selected-card='true'] {
  &.create-add-button {
    box-shadow: 0px 0px 0px 2px $primary100;
    background: transparent;
  }
}
</style>
